import * as React from 'react';
import { ArrowBackIos } from "@mui/icons-material";
import Button from "components/UI/Button";
import FlexboxContainerComponent from "components/UI/FlexboxContainer";
import Breadcrumbs from 'components/UI/Breadcrumb';
import { GENERAL_CONSTANTS } from "constants/general";
import { navigate } from "hooks/useHookRouterCompat";
import styled from "styled-components";
import { Main } from "styles/themeColors";
import { Space } from "styles/themeSpaces";

const BackButton = styled(Button)`
  margin-left: ${Space.sp3x};
  margin-top: ${Space.sp3x};
`;

// Type definitions
interface NavigationProps {
  currentPath: string;
  previousPath: string | null;
  showBreadcrumbs: boolean;
  crumbs: Array<{
    name: string;
    path: string;
  }>;
}

// Navigation component with breadcrumbs and back button
const RootNavigation: React.FC<NavigationProps> = ({ currentPath, previousPath, showBreadcrumbs, crumbs }) => (
  <FlexboxContainerComponent justifyContent="space-between" bgColor={Main.white}>
    {currentPath.includes('document') && previousPath?.includes('order-details') ? (
      <BackButton
        isGhost
        color={Main.accent}
        borderColor="transparent"
        onClick={() => navigate(previousPath!)}
        leftIcon={() => <ArrowBackIos />}
      >
        {GENERAL_CONSTANTS.BACK}
      </BackButton>
    ) : null}
    {showBreadcrumbs ? (
      <FlexboxContainerComponent padding="10px 30px">
        <Breadcrumbs crumbs={crumbs} />
      </FlexboxContainerComponent>
    ) : null}
  </FlexboxContainerComponent>
);


export default RootNavigation;